module.exports = __webpack_public_path__ + "static/media/modal-lock-icon.522897c5.svg";